import styled from '@emotion/styled';

export default styled.span({
    textDecoration: 'line-through'
});
